import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {Para} from "@irati/ui/src/Labels"

export const ResponsiveFlexWrapper = styled.div`
  display: flex;
  ${minWidthMedia.tablet`
    display: block;
  `}
`

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0 auto 30px;
  justify-content: center;
`

export const Flex = styled.div`
  display: flex;
`

export const StyledPara = styled(Para)`
  margin-left: 10px;
  display: inline;
`
